import React, { useState, useEffect, useContext } from 'react';
import Select from '../../Deployments/Deployment.styles';
import api from '../../../api'; // Ensure this is the correct path to your API instanc
import Box from '../../../components/utility/box';
import noDataImg from '@iso/assets/images/no-data-found.svg';
import CreateTaskHeader from "../../ScrumBoard/Task/TaskCreateOrUpdate/CreateTaskHeader/CreateTaskHeader";
import { AppContext } from "../../../context/ContextProvider";
import initialData from '../../../redux/scrumBoard/data';
import { SelectOption as Option } from '@iso/components/uielements/select';
import { Button, Form, message, Tooltip, Alert, Modal } from 'antd';
import { Input, Spin } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import CreateTaskFooter from '../../ScrumBoard/Task/TaskCreateOrUpdate/CreateTaskFooter/CreateTaskFooter';
import { useDeploymentFeatures } from '../../../containers/Dashboard/CustomHooks/useDeploymentFeatures';
import { CustomModal } from '../../Dashboard/CustomComponents/PageLoader.style';
// import CryptoJS from 'crypto-js';
import noDataPlusIcon from '@iso/assets/images/nodata-plus-icon.svg';
import { Link, useNavigate } from 'react-router-dom';
import UploadFiles from '../../../components/utility/UploadFiles';
import learnMoreImg from '../../../assets/images/learnMoreImg.svg';
import { copyText, formatErrors, timeSince } from '../../../context/helper';
import copyIcon from "@iso/assets/images/copyImg.svg";

const { regions } = initialData;

const noDataSubTitle = {
  color: "#323232",
  fontFamily: "Poppins",
  fontSize: "12px",
  fontStyle: "normal",
  fontWeight: "400",
  marginLeft: "5px"
};


let learnMoreStyle = {
  flexGrow: "0",
  fontFamily: "Nunito Sans",
  fontSize: "14px",
  fontWeight: "600",
  fontStretch: "normal",
  fontStyle: "normal",
  lineHeight: "1.71",
  letterSpacing: "normal",
  textAlign: "left",
  color: "#45d1ff",
  marginTop: "1px"
};

const BringYourClusterDrawer = ({ visible, onClose, autoTokenImport }) => {

  const { toggleAlert } = useDeploymentFeatures();
  const [accounts, setAccounts] = useState([]);
  const [selectRegions, setSelectRegions] = useState([]);
  const cloudProviders = ['AWS (EKS)', 'GCP (GKE)', 'Import via token']; // 'Azure (AKS)'
  const clusterTypesDropdownList = ['PUBLIC', "PUBLIC + PRIVATE", 'PRIVATE']; // 'Azure (AKS)'
  // const clusterTypesDropdownList = ['PUBLIC', 'PRIVATE']; // 'Azure (AKS)'
  const [tooltipTxt, setTooltipTxt] = useState({});
  const { setOpenRightDrawer, refreshBoardList, setRefreshBoardList, profileData, dispatch } = useContext(AppContext);
  const [payload, setPayload] = useState({
    selectedAccount: null,
    selectedCloudProvider: null,
    selectedClusterType: "PUBLIC",
    privateSecretKey: "",
    selectedRegion: null,
    zone: null,
    clusterName: '',
    clusterIntegrationType: 0,
    accessKey: "",
    secretKey: "",
    endpoint: "",
    authToken: "",
    accessMode: "full_access"
  })
  // Read-only-keys continuation flow (AWS): options + generated Debug Agent helm command.
  const [actionRequired, setActionRequired] = useState(null);
  const [helmInfo, setHelmInfo] = useState(null);
  const [helmFetching, setHelmFetching] = useState(false);
  const [encryptedData, setEncryptedData] = useState({
    accessKey: '',
    secretKey: ''
  })
  const [clusterNames, setClusterNames] = useState([]);
  const [clusterListFetching, setClusterListFetching] = useState(false);
  const [file, setFile] = useState();
  const [form] = Form.useForm();

  // Infinite scroll pagination for Target Account dropdown (same pattern as OnSourceClickRightDrawer)
  const [accountsPageCount, setAccountsPageCount] = useState(1);
  const [doneFetchingAccounts, setDoneFetchingAccounts] = useState(false);
  const [accountsFetching, setAccountsFetching] = useState(false);
  const PAGE_SIZE_ACCOUNTS = 10;

  const navigate = useNavigate();

  // Track whether we still need to auto-generate after pre-selecting "Import via token".
  // The pre-selection itself is applied inside the sessionStorage-restore effect below
  // (which does a full payload reset on mount) so it isn't clobbered by that reset.
  const autoGenRef = React.useRef(!!autoTokenImport);

  // Once the provider flips to "Import via token" (onboarding "Deploy agent" path),
  // fire Generate Command once automatically.
  useEffect(() => {
    if (autoGenRef.current && payload.selectedCloudProvider === 'Import via token') {
      autoGenRef.current = false;
      handleGenerateSecret();
    }
  }, [payload.selectedCloudProvider]); // eslint-disable-line react-hooks/exhaustive-deps

  // const encryptSecrets = (data) => {
  //   const salt = CryptoJS.lib.WordArray.random(16);
  //   const staticToken = process.env.REACT_APP_API_ENCRYPT_TOKEN;
  //   const key = CryptoJS.PBKDF2(staticToken, salt, {
  //     keySize: 256 / 32,
  //     iterations: 100000,
  //     hasher: CryptoJS.algo.SHA256,
  //   });

  //   const iv = CryptoJS.lib.WordArray.random(16); // AES-CBC requires 16-byte IV
  //   const encrypted = CryptoJS.AES.encrypt(data, key, { iv: iv, mode: CryptoJS.mode.CBC });

  //   const combined = salt.concat(iv).concat(encrypted.ciphertext);
  //   return CryptoJS.enc.Base64.stringify(combined);
  // }

  useEffect(() => {
    setClusterNames([]);
    const fetchClusterNames = async () => {
      try {
        const body = {};
        console.log("Payload: ", payload);
        if (payload.selectedCloudProvider.includes("AWS")) {
          if (payload.selectedAccount.length > 0 && payload.selectedAccount !== 'fetchUsingCredentials') {
            body.account_id = payload.selectedAccount;
            body.cluster_integration_type = payload.clusterIntegrationType.toString();
          }
        }
        else if (payload.selectedCloudProvider.includes("GCP")) {
          if (payload.selectedAccount.length > 0 && payload.selectedAccount !== 'fetchUsingCredentials') {
            body.account_id = payload.selectedAccount;
            body.cluster_integration_type = payload.clusterIntegrationType.toString();
          }
        }
        if (payload.selectedRegion.length > 0) {
          body.region = payload.selectedRegion;
        }
        api.post(process.env.REACT_APP_API_URI + '/api/cluster/region-based-clusters/', body)
          .then((res) => {
            if (res.data.status) {
              const data = res.data.data;
              console.log('cluster names: ', data.clusters)
              // console.log('Cluster names: ', data);
              setClusterNames(data.clusters)
            }
            else {
              toggleAlert('error', 'Error', 'Error fetching cluster names');

            }
          }).catch((error) => {
            toggleAlert('error', 'Error', 'Something went wrong.')
          }).finally(() => {
            setClusterListFetching(false);
          })

      }
      catch (error) {
        console.log('Error fetching the cluster names: ', error)
        toggleAlert('error', 'Error', 'Something went wrong');
        setClusterListFetching(false);
      }
      // finally {
      //   setClusterListFetching(false);
      // }
    }

    console.log("My payload: ", payload);
    if (payload.selectedRegion && payload.selectedAccount && (payload.clusterIntegrationType || payload.clusterIntegrationType === 0)) {
      setClusterListFetching(true);
      fetchClusterNames();
    }
  }, [payload.selectedRegion, payload.selectedAccount, payload.clusterIntegrationType])

  useEffect(() => {
    if (payload.selectedCloudProvider && payload.selectedCloudProvider !== "Import via token") {
      if (accountsPageCount === 1) {
        setAccounts([]);
        setDoneFetchingAccounts(false);
      }
      const fetchAccounts = async () => {
        if (accountsPageCount === 1) {
          dispatch({ loader: "importCluster", status: "loading" });
        }
        setAccountsFetching(true);
        try {
          let integration_id = "1";
          if (payload.selectedCloudProvider === 'GCP (GKE)') {
            integration_id = "3";
          } else if (payload.selectedCloudProvider === 'AWS (EKS)') {
            integration_id = "1";
          }
          const url = `${process.env.REACT_APP_API_URI}/api/integration/account/list/?from_integrationlist=false&page=${accountsPageCount}&page_size=${PAGE_SIZE_ACCOUNTS}`;
          const response = await api.post(url, { integration_id, is_active: true });
          const data = response.data;

          if (data.status) {
            const cloudProviderMap = {
              'AWS (EKS)': 'aws',
              'GCP (GKE)': 'gcp',
              'Azure (AKS)': 'azure'
            };
            const filVal = cloudProviderMap[payload.selectedCloudProvider];
            const results = (data.data.results || [])
              .filter((account) => [filVal].includes(account.integration_type) && account.integration_state && account.integration_state.toLowerCase() === "active");

            if (results.length < PAGE_SIZE_ACCOUNTS) {
              setDoneFetchingAccounts(true);
            }

            const newOptions = results.map((account) => (
              <Option key={account.account_id} name='selectedAccount' value={account.account_id} data-account-type={account.integration_type} data-integration-id={account.integration}>
                <img src={account.integration_logo} style={{ width: "18px", height: "18px", marginRight: "10px" }} alt="provider" />
                <span>{`${account.account_id}${account.alias ? ` (${account.alias})` : ""}`}</span>
              </Option>
            ));

            setAccounts((prev) => {
              if (accountsPageCount <= 1) {
                return newOptions.length > 0 ? newOptions : [
                  <Option key="no-linked-account" value='noLinkedAccount' name="selectedAccount" data-alias="" type="integration" style={{ background: "white" }}>
                    <div style={{ display: "flex", flexDirection: "column", justifyContent: "space-between", alignItems: "center", height: "fit-content", padding: "3px 0" }}>
                      <img src={noDataImg} alt="No data" />
                      <span>No Linked Account for this Cloud Provider.</span>
                    </div>
                  </Option>
                ];
              }
              return [...prev, ...newOptions];
            });
          }
        } catch (error) {
          console.error('Error fetching accounts:', error);
        } finally {
          setAccountsFetching(false);
          if (accountsPageCount === 1) {
            dispatch({ loader: "importCluster", status: "loaded" });
          }
        }
      };
      fetchAccounts();
    } else {
      // Clear accounts if cloud provider is cleared
      setAccounts([]);
      setSelectRegions([]);
      setClusterNames([]);
    }
  }, [payload.selectedCloudProvider, accountsPageCount])


  useEffect(() => {
    if (payload.selectedAccount) {
      // Extract the account type from the selected account option
      const cloudProviderMap = {
        'AWS (EKS)': 'aws',
        'GCP (GKE)': 'gcp',
        'Azure (AKS)': 'azure'  // Ensure Azure is handled
      };
      const accountType = cloudProviderMap[payload.selectedCloudProvider];
      // accounts.find(account => account.props.value === selectedAccount)?.props['data-account-type'];

      if (accountType && regions[accountType]) {
        const regionsForAccount = regions[accountType];
        const myRegions = Object.keys(regionsForAccount).map((child, ind) => (
          <Option key={`reg-${ind}`} name='selectedRegion' value={child} data-displayname={regionsForAccount[child].name}>
            <div style={{ display: "flex", justifyContent: "start", alignItems: "center", width: "100%" }}>
              <span>{`${regionsForAccount[child].name} / ${child}`}</span>
            </div>
          </Option>
        ));

        setSelectRegions(myRegions.length > 0 ? myRegions : [
          <Option key="0" name="region-redirect" data-alias="" type="integration" style={{ background: "white" }}>
            <div style={{ display: "flex", flexDirection: "column", justifyContent: "space-between", alignItems: "center", height: "fit-content", padding: "3px 0" }}>
              <img src={noDataImg} alt="No data" />
              <span>No region available.</span>
            </div>
          </Option>
        ]);
      } else {
        setSelectRegions([
          <Option key="0" name="region-redirect" data-alias="" type="integration" style={{ background: "white" }}>
            <div style={{ display: "flex", flexDirection: "column", justifyContent: "space-between", alignItems: "center", height: "fit-content", padding: "3px 0" }}>
              <img src={noDataImg} alt="No data" />
              <span>No region available.</span>
            </div>
          </Option>
        ]);
      }
    } else {
      setSelectRegions([
        <Option key="0" name="region-redirect" data-alias="" type="integration" style={{ background: "white" }}>
          <div style={{ display: "flex", flexDirection: "column", justifyContent: "space-between", alignItems: "center", height: "fit-content", padding: "3px 0" }}>
            <img src={noDataImg} alt="No data" />
            <span>No region available.</span>
          </div>
        </Option>
      ]);
    }
  }, [payload.selectedAccount, accounts]);

  const callZonesApi = () => {
    // api.get(process.env.REACT_APP_API_URI + `/api/cluster/gcp/zones/?project_id=${payload.}&region=${payload.selectedRegion}&cluster_unique_id=${}`)
  }

  const bringYourCluster = async () => {
    try {
      await form.validateFields();
      dispatch({ loader: "importCluster", status: "loading" });
      const body = {};
      if (payload.selectedCloudProvider === "Import via token") {
        body.auth_token = payload.authToken;
        body.cluster_api_server = payload.endpoint;
        body.skip_tls_verify = false;
      }
      else {
        if (payload.selectedCloudProvider.includes("AWS")) {
          if (payload.selectedAccount.length > 0 && payload.selectedAccount !== 'fetchUsingCredentials') {
            body.account_id = payload.selectedAccount;
          }
          body.cluster_integration_type = payload.clusterIntegrationType.toString();
          // if (payload.accessKey.length > 0) {
          //   body.aws_access_key_id = encryptedData.accessKey;
          // }
          // if (payload.secretKey.length > 0) {
          //   body.aws_secret_access_key = encryptedData.secretKey;
          // }
        }
        else if (payload.selectedCloudProvider.includes("GCP")) {
          if (payload.selectedAccount.length > 0 && payload.selectedAccount !== 'fetchUsingCredentials') {
            body.account_id = payload.selectedAccount;
            body.cluster_integration_type = payload.clusterIntegrationType.toString();
          }
        }
        if (payload.clusterName.length > 0) {
          body.cluster_name = payload.clusterName;
        }
        if (payload.selectedRegion.length > 0) {
          if (checkGcp) {
            // payload.clusterType === "Zonal" ? body.region = payload.zone : body.region = payload.selectedRegion;
            console.log("My final payload...", payload);
            const checkZone = (payload.zone.endsWith("-a") || payload.zone.endsWith("-b") || payload.zone.endsWith("-c"));
            body.region = checkZone ? undefined : payload.selectedRegion;
            body.zone = checkZone ? payload.zone : undefined;
          }
          else {
            body.region = payload.selectedRegion;
          }
        }
      }
      if (payload.selectedCloudProvider !== "Import via token") {
        body.access_mode = payload.accessMode || 'full_access';
      }
      const apiCall = payload.selectedCloudProvider === "Import via token" ? api.post(process.env.REACT_APP_API_URI + '/api/cluster/bring-k8s-cluster-with-token/', body)
        : api.post(process.env.REACT_APP_API_URI + '/api/cluster/bring-your-clusters/', body);
      apiCall.then((res) => {
        if (res.data.status) {
          const data = res.data;
          console.log('Cluster brought successfully', data);
          // Read-only AWS import via read-only keys: cluster was created but needs the
          // customer to attach a policy or install the Debug Agent. Show the options.
          if (res.data?.data?.action_required) {
            setActionRequired(res.data.data);
            dispatch({ loader: "importCluster", status: "loaded" });
            return;
          }
          handleCancel(true);
          toggleAlert('success', 'Success', 'Job to import your cluster has been submitted successfully');
          sessionStorage.removeItem('bycFormValues');
          form.setFieldsValue({
            selectedCloudProvider: null,
            selectedClusterType: "PUBLIC",
            selectedAccount: null,
            selectedRegion: null,
            clusterName: null,
            clusterIntegrationType: null,
            clusterType: null,
            zone: null,
            endpoint: "",
            authToken: ""
          });
          // setRefreshBoardList(!refreshBoardList);
        }
        else {
          if (res.data?.data?.detail) {
            toggleAlert('error', 'Failed', res.data.data.detail);
          }
          else {
            toggleAlert("error", "Failed", formatErrors(res.data.error_details));
          }
        }
      }).catch((error) => {
        console.log('Error in bring your cluster: ', error);
        // Surface the actual backend error (e.g. "this cluster already exists") instead
        // of a generic message. Non-2xx responses land here with the payload on
        // error.response.data — same shape the .then else branch reads.
        const resp = error?.response?.data;
        const msg = resp?.data?.detail
          || (resp?.error_details ? formatErrors(resp.error_details) : null)
          || resp?.message
          || 'Not able to import your cluster.';
        toggleAlert('error', 'Failed', msg);
      }).finally(() => dispatch({ loader: "importCluster", status: "loaded" }))

    } catch (error) {
      console.log('Error in bring your cluster: ', error);
      // setLoading(false);
    }
  }

  const handleAccountsPopupScroll = (e) => {
    const { scrollTop, scrollHeight, clientHeight } = e.currentTarget;
    if (!doneFetchingAccounts && (scrollHeight - scrollTop <= clientHeight + 10) && !accountsFetching) {
      setAccountsPageCount((prev) => prev + 1);
      setAccountsFetching(true);
    }
  };

  const handleSelectChange = (value, event) => {
    console.log('handleSelectChange value:', value, 'event:', event);

    if (event.name === 'selectedCloudProvider') {
      setAccountsPageCount(1);
      setDoneFetchingAccounts(false);
      setAccounts([]);
      setSelectRegions([]);
      setClusterNames([]);
      setPayload(prevPayload => ({
        ...prevPayload,
        selectedCloudProvider: value, // IMPORTANT: Update the cloud provider value
        selectedAccount: null,
        selectedClusterType: "PUBLIC",
        privateSecretKey: "",
        clusterName: '',
        selectedRegion: null,
        authToken: "",
        endpoint: "",
        zone: null,
        clusterIntegrationType: 0
      }));
      
      form.setFieldsValue({
        'selectedCloudProvider': value, // IMPORTANT: Update form value
        'selectedAccount': null,
        'clusterName': null,
        'selectedClusterType': "PUBLIC",
        'privateSecretKey': "",
        'selectedRegion': null,
        'zone': null,
        'accessKey': "",
        'secretKey': "",
        'authToken': "",
        'endpoint': ""
      });
      
      // Clear session storage or update it with new cloud provider
      const updatePayload = {
        selectedCloudProvider: value,
        selectedClusterType: "PUBLIC",
        privateSecretKey: "",
        selectedAccount: null,
        selectedRegion: null,
        clusterName: null,
        clusterIntegrationType: 0,
        clusterType: null,
        zone: null,
      };
      sessionStorage.setItem('bycFormValues', JSON.stringify(updatePayload));
    } else if (event.name === 'selectedAccount') {
      let finalValue = value;
      if (value === 'noLinkedAccount') {
        finalValue = null;
      }
      const selectedIntegrationId = event["data-db-id"];
      const clusterIntegrationType = event["data-integration-id"];
      console.log("Updating selectedAccount. ID:", selectedIntegrationId);

      setPayload(prevPayload => {
        const newPayload = {
          ...prevPayload,
          selectedAccount: finalValue,
          accessKey: '',
          secretKey: '',
          selectedRegion: null,
          clusterIntegrationType: clusterIntegrationType,
          selectedIntegrationId: selectedIntegrationId
        };
        
        const updatePayload = {
            ...newPayload,
            selectedCloudProvider: form.getFieldValue('selectedCloudProvider'),
            selectedClusterType: form.getFieldValue('selectedClusterType'),
            clusterName: null,
            zone: null
        };
        sessionStorage.setItem('bycFormValues', JSON.stringify(updatePayload));
        return newPayload;
      });

      form.setFieldsValue({
        'selectedAccount': finalValue,
        'selectedRegion': null,
        'clusterName': null,
        'accessKey': '',
        'secretKey': ''
      });
      setClusterNames([]);
    } else {
      // Handle other fields
      if (event.name === 'selectedRegion') {
        form.setFieldValue('clusterName', null);
      }
      if (event.name === 'clusterName') {
        if (value === 'noClusterFound') form.setFieldValue('clusterName', null);
        if (checkGcp && event['data-zone']) form.setFieldValue('zone', event['data-zone']);
      }

      setPayload(prevPayload => {
        let newPayload = { ...prevPayload };
        
        if (event.name === 'selectedRegion') {
          newPayload.selectedRegion = value;
          newPayload.clusterName = null;
        } else if (event.name === 'clusterName') {
          if (value === 'noClusterFound') {
            newPayload.clusterName = null;
          } else {
            newPayload.clusterName = value;
          }
          if (checkGcp && event['data-zone']) {
             newPayload.zone = event['data-zone'];
          }
        } else {
          newPayload[event.name] = value;
        }

        const updatePayload = {
            ...newPayload,
            selectedCloudProvider: form.getFieldValue('selectedCloudProvider'),
            selectedClusterType: form.getFieldValue('selectedClusterType'),
            selectedAccount: newPayload.selectedAccount,
            selectedRegion: newPayload.selectedRegion,
            clusterName: newPayload.clusterName,
            zone: newPayload.zone,
            selectedIntegrationId: newPayload.selectedIntegrationId
        };
        sessionStorage.setItem('bycFormValues', JSON.stringify(updatePayload));
        
        return newPayload;
      });
    }
  }

  useEffect(() => {
    let selectedPayload = JSON.parse(sessionStorage.getItem('bycFormValues'))
    if (!selectedPayload) {
      selectedPayload = {
        selectedCloudProvider: null,
        selectedClusterType: "PUBLIC",
        privateSecretKey: null,
        selectedAccount: null,
        selectedRegion: null,
        clusterName: null,
        clusterIntegrationType: null,
        clusterType: null,
        zone: null,
      }
    }
    // Onboarding "Deploy the agent directly" path: force Import-via-token mode,
    // overriding any previously saved selection. This is the single place that
    // initialises payload on mount, so the choice sticks (and the auto-generate
    // effect then fires).
    if (autoTokenImport) {
      selectedPayload = { ...selectedPayload, selectedCloudProvider: 'Import via token' };
    }
    setPayload(selectedPayload)
    form.setFieldsValue({
      selectedCloudProvider: selectedPayload?.selectedCloudProvider,
      selectedClusterType: selectedPayload?.selectedClusterType === "PRIVATE" ? "PRIVATE" : (selectedPayload?.selectedClusterType === "PUBLIC + PRIVATE" ? "PUBLIC + PRIVATE" : "PUBLIC"),
      // selectedClusterType: selectedPayload?.selectedClusterType === "PRIVATE" ? "PRIVATE" : "PUBLIC",
      privateSecretKey: selectedPayload?.privateSecretKey,
      selectedAccount: selectedPayload?.selectedAccount,
      selectedRegion: selectedPayload?.selectedRegion,
      clusterName: selectedPayload?.clusterName,
      clusterIntegrationType: selectedPayload?.clusterIntegrationType,
      clusterType: selectedPayload?.clusterType,
      zone: selectedPayload?.zone,
    });
  }, [])

  const handleChange = (event) => {
    if (event.target.name === 'accessKey' || event.target.name === 'secretKey') {
      setPayload(prevPayload => ({
        ...prevPayload,
        selectedRegion: null,
      }))
      form.setFieldValue('selectedRegion', null);
      sessionStorage.setItem("bycFormValues", JSON.stringify({ ...data, selectedRegion: null }));
    }
    setPayload((data) => ({ ...data, [event.target.name]: event.target.value }));
    const data = JSON.parse(sessionStorage.getItem("bycFormValues"));
    sessionStorage.setItem("bycFormValues", JSON.stringify({ ...data, [event.target.name]: event.target.value }));
  }

  const handelCancel = (fromByoc) => {
    console.log("Cancel clicked: ", fromByoc);

    setOpenRightDrawer({
      drawerType: false,
      drawerProps: {
        data: "",
      },
    });
    if (fromByoc && payload.selectedCloudProvider !== "Import via token") {
      const importData = {
        id: new Date(),
        title: payload.selectedAccount,
        name: payload.clusterName,
        region: payload.selectedRegion,
        type: "default",
        isStarred: false,
        updatedAt: (new Date()).toISOString(),
        calculatedUpdatedAt: `${timeSince(new Date())} ago`,
        createdAt: (new Date()).toISOString(),
        createdBy: (profileData?.first_name + " " + profileData?.last_name),
        liveStatus: "IMPORTING",
        status: "IMPORTING",
        version: "",
        integrationType: payload.clusterIntegrationType,
        img: "",
        organisation: "",
        userManagedNodegroupsExist: false,
        notification_details: undefined,
        version_notification: undefined,
        provisioner: "imported",
        hasAddons: false,
        isAutoModeCluster: false,
        isAccountIntegrated: true,
        isOpen: false,            // this is for 3 dots open/close
      };
      navigate("/clusters", {
        state: {
          data: {
            from: fromByoc ? "fromByoc" : "",
            data: { ...importData }
          }
        }
      });
    }
  }
  const handleCancel = (fromByoc) => {
    if (fromByoc === true) {
      handelCancel(true);
    }
    else {
      handelCancel();
    }
  }

  const checkGcp = payload.selectedCloudProvider?.includes("GCP");


  const handleReadFile = (file) => {
    const reader = new FileReader();
    console.log("Files... :", file);

    reader.onload = (e) => {
      try {
        // console.log("e.target :", e.target);
        console.log("e.target.result :", e.target.result);
        message.success(`${file.name} uploaded successfully. Please proceed.`);
      } catch (error) {
        console.error('Error parsing .env file:', error);
      }
    };

    if (file) {
      console.log("File path: ", file);
      setFile(file);
      // setFile({
      //     ...file,
      //     uid: file.uid,
      //     name: file.name,
      //     status: 'done',
      // });
      //setDataSourceTasks({...dataSourceTasks, file: file});
      reader.readAsText(file);
    }
  };

  const copyFunc = async (e, text) => {
    let res = await copyText(text);
    console.log("Tooltip: ", e.target.name, res);
    setTooltipTxt({
        [e.target.name]: "Copied"
    });
    setTimeout(() => {
        setTooltipTxt({
            [e.target.name]: ""
        });
    }, 2000);
  }

  // Full-access import -> Ops Agent (full/admin token); read-only -> Debug Agent (read-only token).
  const isFullAccessAction = (actionRequired?.access_mode || payload?.accessMode) === 'full_access';
  const actionAgentLabel = isFullAccessAction ? 'Ops Agent' : 'Debug Agent';
  // Option 1 policy: full_access import needs the superset (S3/ECR for pipelines);
  // read_only needs the minimal import policy.
  const actionPolicyName = (isFullAccessAction ? actionRequired?.full_access_policy_name : actionRequired?.import_policy_name)
    || (isFullAccessAction ? "AtmoslyEKSFullAccessPolicy" : "AtmoslyEKSImportPolicy");
  const actionPolicyDocument = isFullAccessAction ? actionRequired?.full_access_policy_document : actionRequired?.import_policy_document;

  const fetchAgentCommand = async () => {
    if (!actionRequired?.cluster_unique_id) return;
    const endpoint = isFullAccessAction ? 'ops-agent-command' : 'debug-agent-command';
    setHelmFetching(true);
    try {
      const res = await api.get(`${process.env.REACT_APP_API_URI}/api/cluster/cluster/${actionRequired.cluster_unique_id}/${endpoint}/`);
      const data = res.data?.data || res.data;
      setHelmInfo(data);
    } catch (error) {
      console.log('Error fetching agent command: ', error);
      toggleAlert('error', 'Failed', `Could not generate the ${actionAgentLabel} install command.`);
    } finally {
      setHelmFetching(false);
    }
  };

  const closeActionRequired = () => {
    setActionRequired(null);
    setHelmInfo(null);
    handleCancel(true);
  };

  const handleGenerateSecret = () => {
    const body = {
      cluster_name: payload.clusterName,
      cloud_account: payload.selectedIntegrationId,
      region: payload.selectedRegion,
      cluster_type: payload.selectedClusterType
    };
    console.log("handleGenerateSecret body: ", body);
    api.post(`${process.env.REACT_APP_API_URI}/api/users/generate-secret/`, body).then((res) => {
      let data = res.data;
      console.log("this is handleGenerateSecret data :", data);

      if(data.status){
        const secretValue = data.data.secret;
        const kubegatewayUrl = process.env.REACT_APP_KUBEGATEWAY || '';
        const backendUrl = process.env.REACT_APP_API_URI || '';
        const djangoUrl = process.env.REACT_APP_DJANGO_BACKEND_URL || process.env.REACT_APP_API_URI || '';
        
        // Generate Helm command by access mode: Read Only -> Debug Agent (read-only token);
        // Full Access -> Ops Agent bundle (cluster-admin token). The agent type the user
        // installs is what sets the cluster's access_mode when it registers back.
        const helmCommand = payload.accessMode === "read_only"
          ? `helm upgrade --install debug-agent oci://public.ecr.aws/g7z5u7g9/debug-agent --version 0.4.0 --set debugAgent.clusterSecret="${secretValue}"`
          : `helm upgrade --install agent oci://public.ecr.aws/g7z5u7g9/atmosly-kube-agents --version 0.4.0 --set global.clusterSecret="${secretValue}"`;

        setPayload((prev) => {
          form.setFieldValue("privateSecretKey", helmCommand);
          return{
            ...prev,
            privateSecretKey: helmCommand
          }
        });
      }
      else{
        console.log("error :", data.data);
      }
    }).catch((error) => {
      console.log("error :", error);
    });
  }


  return (
    <>
      {console.log("New payload...", payload)}
      {/* <CustomModal
        visible={loading}
        //onCancel={hideModal}
        footer={null}
        closable={false}
        centered
        maskClosable={false}
        style={{ border: "none", boxShadow: "none", zIndex: loading ? 1100 : -1 }}
      >
        <div style={{ textAlign: 'center', background: "transparent", border: "none" }}>
          <Spin size="large" />
        </div>
      </CustomModal> */}
      <CreateTaskHeader
        buttonContent={"Bring your cluster"}
        onCancel={() => {
          setOpenRightDrawer({
            drawerType: false,
            drawerProps: {
              data: null
            },
          });
        }}
      />
      <div style={{ padding: "20px 0px 40px 0px" }}>

        <Form
          form={form}
          preserve={false}
          name="dynamic_rule"
        >
          <Box style={{ borderRadius: "20px", position: "relative", marginBottom: "60px", marginTop: "8vh", border: '0px', paddingLeft: '20px' }}>
            <div style={{ width: "96%" }}>
              <Box
                title={<div>
                  <p>Cloud Provider* </p>
                </div>}
                subtitle="Select the cloud provider."
                style={{ border: "transparent", marginBottom: '0', padding: '0' }}
              />
              <div style={{ display: "flex", flexDirection: "column" }}>
                <Form.Item
                  name="selectedCloudProvider"
                  rules={[
                    {
                      required: true,
                      message: 'Please select your cloud provider.',
                    }
                  ]}
                >
                  <Select
                    style={{ borderRadius: "10px" }}
                    placeholder="Please select the cloud provider"
                    onChange={handleSelectChange}
                    value={payload.selectedCloudProvider}
                  >
                    {cloudProviders.map((provider, idx) => (
                      <Option key={idx} name="selectedCloudProvider" data-alias="" type="cloud-provider" value={provider}>
                        <span>{provider}</span>
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </div>
            </div>

            {payload.selectedCloudProvider !== "Import via token" && <>
              <div style={{ width: "96%" }}>
                <Box
                  title={<div style={{ display: "flex" }}>
                    <p>Target Account* </p>
                  </div>}
                  subtitle="Select the cloud account where the cluster will be deployed."
                  style={{ border: "transparent", marginBottom: "0", padding: '0' }}
                />
                <div style={{ display: "flex", flexDirection: "column" }}>
                  <Form.Item
                    name="selectedAccount"
                    rules={[
                      {
                        required: true,
                        message: 'Please select the target account.',
                      }
                    ]}
                  >
                    <Select
                      style={{ borderRadius: "10px" }}
                      placeholder="Please select a Target Account Id"
                      onChange={handleSelectChange}
                      value={payload.selectedAccount}
                      disabled={!payload.selectedCloudProvider || (accounts.length === 0 && !accountsFetching)}
                      onPopupScroll={handleAccountsPopupScroll}
                      getPopupContainer={(triggerNode) => triggerNode.parentNode}
                      dropdownRender={(menu) => (
                        <div>
                          {accounts.length === 0 && accountsFetching ? (
                            <div style={{ textAlign: 'center', padding: 8 }}>
                              <Spin size="small" />
                            </div>
                          ) : (
                            menu
                          )}
                          {!doneFetchingAccounts && accounts.length > 0 && accountsFetching && (
                            <div style={{ textAlign: 'center', padding: 6 }}>
                              <Spin size="small" />
                            </div>
                          )}
                        </div>
                      )}
                    >
                      {accounts.length > 0 ? accounts :
                        !accountsFetching ? (
                          <Option key="0" name='selectedAccount' data-alias="" type="integration" style={{ background: "white" }}>
                            <div style={{ display: "flex", flexDirection: "column", justifyContent: "space-between", alignItems: "center", height: "fit-content", padding: "3px 0" }}>
                              <img src={noDataImg} alt="No data" />
                              <span>No account available.</span>
                              <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                                <Link to='/integration' style={{ textDecoration: 'none', color: 'inherit' }}>
                                  <img src={noDataPlusIcon} />
                                  <span style={noDataSubTitle}>Create one</span>
                                </Link>
                              </div>
                            </div>
                          </Option>
                        ) : (
                          <Option key="accounts-loader">
                            <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "40px" }}>
                              <Spin size="small" />
                            </div>
                          </Option>
                        )
                      }
                    </Select>
                  </Form.Item>
                </div>
              </div>
              {/* {payload.selectedAccount === 'fetchUsingCredentials' && (
              <>
                <div style={{ width: "96%" }}>
                  <Box
                    title={<div>
                      <p>Access Key* </p>
                    </div>}
                    subtitle="Please provide your access key"
                    style={{ border: "transparent", marginBottom: "0", padding: '0' }}
                  />
                  <div style={{ display: "flex", flexDirection: "column" }}>
                    <Form.Item
                      name="accessKey"
                      rules={[
                        {
                          required: true,
                          message: 'Please enter your access key.',
                        }
                      ]}
                    >
                      <Input
                        placeholder="Enter your access key"
                        value={payload.accessKey}
                        style={{ height: "44px" }}
                        name="accessKey"
                        onChange={handleChange}
                      />
                    </Form.Item>
                  </div>
                </div>
                <div style={{ width: "96%" }}>
                  <Box
                    title={<div>
                      <p>Secret Key* </p>
                    </div>}
                    subtitle="Please provide your secret key"
                    style={{ border: "transparent", marginBottom: '0', padding: '0' }}
                  />
                  <div style={{ display: "flex", flexDirection: "column" }}>
                    <Form.Item
                      name="secretKey"
                      rules={[
                        {
                          required: true,
                          message: 'Please enter your secret key.',
                        }
                      ]}
                    >
                      <Input
                        placeholder="Enter your secret key"
                        value={payload.secretKey}
                        style={{ height: "44px" }}
                        name="secretKey"
                        onChange={handleChange}
                      />
                    </Form.Item>
                  </div>
                </div>
              </>
            )
            } */}

              <div style={{ width: "96%" }}>
                <Box
                  title={<div>
                    <p>Region* </p>
                  </div>}
                  subtitle="Select the region where the cluster will be deployed."
                  style={{ border: "transparent", marginBottom: '0', padding: '0' }}
                />
                <div style={{ display: "flex", flexDirection: "column" }}>
                  <Form.Item
                    name="selectedRegion"
                    rules={[
                      {
                        required: true,
                        message: 'Please select your region.',
                      }
                    ]}
                  >
                    <Select
                      style={{ borderRadius: "10px" }}
                      placeholder="Please select a Region"
                      value={payload.selectedRegion}
                      onChange={handleSelectChange}
                      showSearch
                      disabled={!payload.selectedAccount || (payload.selectedAccount === 'fetchUsingCredentials' ? payload.accessKey.length === 0 || payload.secretKey.length === 0 : false)}
                    >
                      {selectRegions}
                    </Select>
                  </Form.Item>
                </div>
              </div>
              <div style={{ width: "96%" }}>
                <Box
                  title={<div>
                    <p>Cluster Name* </p>
                  </div>}
                  subtitle="Select the Cluster you want to bring."
                  style={{ border: "transparent", marginBottom: '0', padding: '0' }}
                />
                <div style={{ display: "flex", flexDirection: "column" }}>
                  <Form.Item
                    name="clusterName"
                    rules={[
                      {
                        required: true,
                        message: 'Please select your cluster name.',
                      }
                    ]}
                  >
                    {console.log("clusterListFetching :", clusterListFetching)}
                    <Select
                      style={{ borderRadius: "10px" }}
                      placeholder="Please select your cluster"
                      onChange={handleSelectChange}
                      disabled={!payload.selectedRegion || payload.selectedRegion.length < 1} // Disable if no region is selected
                      notFoundContent={clusterListFetching ? <Spin size="small" /> : null}
                      showSearch
                    >
                      {console.log('cluster names in return:', clusterNames)}
                      {clusterNames && clusterNames.length > 0 ? clusterNames.map((clusname, idx) => (
                        checkGcp ? <Option key={idx} name='clusterName' data-alias="" type='cluster-names' data-zone={clusname.location} value={clusname.name}>
                          <span>{clusname.name}({clusname.location})</span>
                        </Option> : <Option key={idx} name='clusterName' data-alias="" type='cluster-names' value={clusname}>
                          <span>{clusname}</span>
                        </Option>
                      )) : !clusterListFetching &&
                      <Option key="0" name="clusterName" value='noClusterFound' data-alias="" style={{ background: "white" }}>
                        <div style={{ display: "flex", flexDirection: "column", justifyContent: "space-between", alignItems: "center", height: "fit-content", padding: "3px 0" }}>
                          <img src={noDataImg} alt="No data" />
                          <span>No cluster available.</span>
                        </div>
                      </Option>
                      }
                    </Select>
                  </Form.Item>
                </div>
              </div>
            </>}

            {payload.selectedCloudProvider !== "Import via token" && <>
              <div style={{ width: "96%" }}>
                <Box
                  title={<div>
                    <p>Cluster Type*</p>
                  </div>}
                  subtitle="Select the custer type."
                  style={{ border: "transparent", marginBottom: '0', padding: '0' }}
                />
                <div style={{ display: "flex", flexDirection: "column" }}>
                  <Form.Item
                    name="selectedClusterType"
                    rules={[
                      {
                        required: true,
                        message: 'Please select your cluster type.',
                      }
                    ]}
                  >
                    <Select
                      style={{ borderRadius: "10px" }}
                      name="selectedClusterType"
                      placeholder="Please select the cluster type"
                      onChange={handleSelectChange}
                      value={payload.selectedClusterType ? payload.selectedClusterType : undefined}
                    >
                      {clusterTypesDropdownList.map((provider, idx) => (
                        <Option key={idx} name="selectedClusterType" value={provider}>
                          <span>{provider}</span>
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </div>
              </div>
            </>}
            
            {payload.selectedCloudProvider !== "Import via token" && <>
              <div style={{ width: "96%" }}>
                <Box
                  title={<div><p>Access Mode*</p></div>}
                  subtitle="Read Only lets Atmosly view nodes, pods and workloads without creating anything inside your cluster. Full Access also enables addons, actions and remediation."
                  style={{ border: "transparent", marginBottom: '0', padding: '0' }}
                />
                <div style={{ display: "flex", flexDirection: "column" }}>
                  <Form.Item>
                    <Select
                      style={{ borderRadius: "10px" }}
                      placeholder="Select access mode"
                      value={payload.accessMode || "full_access"}
                      onChange={(val) => setPayload(prev => ({ ...prev, accessMode: val }))}
                    >
                      <Option key="full_access" value="full_access"><span>Full Access</span></Option>
                      <Option key="read_only" value="read_only"><span>Read Only</span></Option>
                    </Select>
                  </Form.Item>
                  {/* What Atmosly will create on import — differs by access mode (and AWS vs GCP). */}
                  {(() => {
                    const isAws = (payload.selectedCloudProvider || "").includes("AWS");
                    const readOnly = (payload.accessMode || "full_access") === "read_only";
                    const ulStyle = { margin: "6px 0 0 0", paddingLeft: "18px", fontSize: "12.5px", lineHeight: 1.6, color: "#292929" };
                    const code = { background: "#f0f0f0", borderRadius: "4px", padding: "0 4px", fontSize: "12px" };
                    return (
                      <Alert
                        type="info"
                        showIcon
                        style={{ marginTop: "4px", borderRadius: "8px" }}
                        message={<span style={{ fontWeight: 600 }}>
                          {readOnly ? "Read Only — what Atmosly creates on import" : "Full Access — what Atmosly creates on import"}
                        </span>}
                        description={
                          <ul style={ulStyle}>
                            {isAws ? (
                              readOnly ? (
                                <>
                                  <li><b>In AWS:</b> an EKS <b>access entry</b> mapping Atmosly's IAM principal to <b>AmazonEKSAdminViewPolicy</b> (read-only view of nodes, pods, workloads, secrets and CRDs).</li>
                                  <li><b>In your cluster:</b> nothing — no namespace, service account or workloads are created.</li>
                                </>
                              ) : (
                                <>
                                  <li><b>In AWS:</b> an EKS <b>access entry</b> mapping Atmosly's IAM principal to <b>AmazonEKSClusterAdminPolicy</b> (cluster-admin).</li>
                                  <li><b>In your cluster:</b> the <span style={code}>atmosly-addons</span> namespace, an <span style={code}>atmosly-service-account</span> ServiceAccount bound to cluster-admin, and its access-token Secret.</li>
                                </>
                              )
                            ) : (
                              readOnly ? (
                                <>
                                  <li><b>In GCP:</b> read access via the connected service account (Kubernetes Engine Viewer) — nothing is created in your Google project.</li>
                                  <li><b>In your cluster:</b> nothing — no namespace, service account or workloads are created.</li>
                                </>
                              ) : (
                                <>
                                  <li><b>In GCP:</b> access via the connected service account (Kubernetes Engine Admin).</li>
                                  <li><b>In your cluster:</b> the <span style={code}>atmosly-addons</span> namespace, an <span style={code}>atmosly-service-account</span> ServiceAccount bound to cluster-admin, and its access-token Secret.</li>
                                </>
                              )
                            )}
                          </ul>
                        }
                      />
                    );
                  })()}
                </div>
              </div>
            </>}

            {/* {console.log("payload.selectedClusterType :", payload.selectedClusterType)} */}
            {/* {payload.selectedCloudProvider === "Import via token" && ["PUBLIC", "PUBLIC + PRIVATE"].includes(payload.selectedClusterType) && <>
            {payload.selectedCloudProvider === "Import via token" && ["PUBLIC"].includes(payload.selectedClusterType) && <>

              <div style={{ display: "flex", cursor: "pointer", width: "fit-content", marginBottom: "20px" }} onClick={() => {
                window.open(process.env.REACT_APP_CLUSTER_TOKEN_SCRIPT_URI, "_blank");
              }}>
                <img src={learnMoreImg} style={{ marginRight: "10px" }} />
                <p style={learnMoreStyle}>Click here to download the script for fetching token and endpoint</p>
              </div>

              <div style={{ width: "96%" }}>
                <Box
                  title={<div style={{ display: "flex" }}>
                    <p>Token* </p>
                  </div>}
                  subtitle="Enter your cloud authentication account token."
                  style={{ border: "transparent", marginBottom: "0", padding: '0' }}
                />
                <div style={{ display: "flex", flexDirection: "column" }}>
                  <Form.Item
                    name="authToken"
                    rules={[
                      {
                        required: true,
                        message: 'Please enter Authentication Token.',
                      }
                    ]}
                  >
                    <Input
                      name="authToken"
                      value={payload.authToken}
                      onChange={handleChange}
                      style={{ height: "44px" }}
                      placeholder='Please enter auth token'
                    />
                  </Form.Item>
                </div>
              </div>

              <div style={{ width: "96%" }}>
                <Box
                  title={<div style={{ display: "flex" }}>
                    <p>Endpoint* </p>
                  </div>}
                  subtitle="Enter endpoint"
                  style={{ border: "transparent", marginBottom: "0", padding: '0' }}
                />
                <div style={{ display: "flex", flexDirection: "column" }}>
                  <Form.Item
                    name="endpoint"
                    rules={[
                      {
                        required: true,
                        message: 'Please enter endpoint.',
                      }
                    ]}
                  >
                    <Input
                      placeholder="Please enter endpoint"
                      name='endpoint'
                      onChange={handleChange}
                      value={payload.endpoint}
                      style={{ height: "44px" }}
                    />
                  </Form.Item>
                </div>
              </div>

              <div style={{ width: "96%" }}>
                <Box
                  title={<div style={{ display: "flex" }}>
                    <p>CA Cert </p>
                  </div>}
                  subtitle="Upload CA Cert file."
                  style={{ border: "transparent", marginBottom: "0", padding: '0' }}
                />

                <div style={{ display: "flex", flexDirection: "column" }}>
                  <Form.Item
                    name="caCert"
                  // rules={[
                  //   {
                  //     required: true,
                  //     message: 'Please enter Authentication Token.',
                  //   }
                  // ]}
                  >
                    <Input 
                    name="authToken" 
                    value={payload.authToken} 
                    onChange={handleChange} 
                    style={{height: "44px"}}
                    placeholder='Please enter auth token'
                    />
                    <UploadFiles types={['.crt']} files={file ? [file] : []} setFiles={setFile} handleReadFile={handleReadFile} />
                  </Form.Item>
                </div>
              </div>
            </>} */}
            {(payload.selectedCloudProvider == "Import via token" || payload.selectedClusterType === "PRIVATE")&& <>
              {payload.selectedCloudProvider === "Import via token" && <>
                <div style={{ width: "96%" }}>
                  <Box
                    title={<div><p>Access Mode*</p></div>}
                    subtitle="Read Only installs the Debug Agent — Atmosly views nodes, pods and workloads. Full Access installs the Ops Agent — also enables addons, actions and remediation."
                    style={{ border: "transparent", marginBottom: '0', padding: '0' }}
                  />
                  <div style={{ display: "flex", flexDirection: "column" }}>
                    <Form.Item>
                      <Select
                        style={{ borderRadius: "10px" }}
                        placeholder="Select access mode"
                        value={payload.accessMode || "full_access"}
                        onChange={(val) => {
                          form.setFieldValue("privateSecretKey", "");
                          setPayload((prev) => ({ ...prev, accessMode: val, privateSecretKey: "" }));
                        }}
                      >
                        <Option key="full_access" value="full_access"><span>Full Access</span></Option>
                        <Option key="read_only" value="read_only"><span>Read Only</span></Option>
                      </Select>
                    </Form.Item>
                  </div>
                </div>
                <Alert
                  type="info"
                  showIcon
                  style={{ width: "96%", marginTop: "8px", borderRadius: "8px" }}
                  message={<span style={{ fontWeight: 600 }}>
                    {payload.accessMode === "read_only"
                      ? "Read Only — what the Debug Agent installs"
                      : "Full Access — what the Ops Agent installs"}
                  </span>}
                  description={
                    payload.accessMode === "read_only" ? (
                      <ul style={{ margin: "6px 0 0", paddingLeft: "18px", fontSize: "12.5px", lineHeight: 1.6, color: "#292929" }}>
                        <li><b>In your cluster:</b> the <code style={{ background: "#f0f0f0", borderRadius: "3px", padding: "0 4px", fontSize: "12px" }}>atmosly-addons</code> namespace, an <code style={{ background: "#f0f0f0", borderRadius: "3px", padding: "0 4px", fontSize: "12px" }}>atmosly-service-account</code> with a read-only token, a read-only ClusterRole/ClusterRoleBinding, and the <code style={{ background: "#f0f0f0", borderRadius: "3px", padding: "0 4px", fontSize: "12px" }}>atmosly-debug-agent</code> pod.</li>
                        <li>Atmosly views nodes, pods and workloads from inside the cluster. Nothing is created in your cloud account.</li>
                      </ul>
                    ) : (
                      <ul style={{ margin: "6px 0 0", paddingLeft: "18px", fontSize: "12.5px", lineHeight: 1.6, color: "#292929" }}>
                        <li><b>In your cluster:</b> the <code style={{ background: "#f0f0f0", borderRadius: "3px", padding: "0 4px", fontSize: "12px" }}>atmosly-addons</code> namespace, an <code style={{ background: "#f0f0f0", borderRadius: "3px", padding: "0 4px", fontSize: "12px" }}>atmosly-service-account</code> bound to <b>cluster-admin</b>, and the Ops Agent pod.</li>
                        <li>Atmosly gets full access from inside the cluster — also enables addons, actions and remediation. Nothing is created in your cloud account.</li>
                      </ul>
                    )
                  }
                />
              </>}
              <div style={{ width: "96%", marginTop: "24px" }}>
                <div style={{ display: "flex", flexDirection: "column" }}>
                  <Form.Item
                    name="privateSecretKey"
                    rules={[
                      {
                        required: true,
                        message: 'Please generate command first.',
                      }
                    ]}
                  >
                    {payload.privateSecretKey ? (
                      <div style={{ marginBottom: "20px" }}>
                        {/* Header Section */}
                        <div style={{ 
                          display: "flex", 
                          justifyContent: "space-between", 
                          alignItems: "center",
                          marginBottom: "12px"
                        }}>
                          <h3 style={{ 
                            margin: 0, 
                            fontFamily: "Nunito Sans",
                            fontSize: "16px",
                            fontWeight: "600",
                            color: "#323232"
                          }}>
                          Install Agent*
                          </h3>
                        </div>

                        {/* Instructional Text */}
                        <p style={{
                          margin: "0 0 16px 0",
                          fontFamily: "Nunito Sans",
                          fontSize: "14px",
                          color: "#666",
                          lineHeight: "1.5"
                        }}>
                          Run this command in your terminal where you have kubectl access to your target cluster.
                        </p>

                        {/* Code Block */}
                        <div style={{
                          position: "relative",
                          backgroundColor: "#1e1e1e",
                          borderRadius: "8px",
                          padding: "16px",
                          fontFamily: "monospace",
                          fontSize: "12px",
                          lineHeight: "1.6",
                          color: "#d4d4d4",
                          marginBottom: "16px",
                          border: "1px solid #3e3e3e"
                        }}>
                          {/* Terminal indicator */}
                          <div style={{
                            position: "absolute",
                            top: "12px",
                            left: "12px",
                            fontSize: "11px",
                            color: "#888",
                            fontFamily: "monospace"
                          }}>
                            _&gt; bash
                          </div>

                          {/* Copy Button */}
                          <Tooltip title={tooltipTxt.password || "Copy"} placement="topRight" open={tooltipTxt.password && tooltipTxt.password !== ""}>
                            <div
                              name="password"
                              onClick={(e) => {
                                copyFunc(e, payload.privateSecretKey);
                              }}
                              style={{
                                cursor: "pointer",
                                position: "absolute",
                                top: "12px",
                                right: "12px",
                                padding: "4px 8px",
                                display: "flex",
                                alignItems: "center",
                                gap: "4px",
                                color: "#d4d4d4",
                                fontSize: "11px",
                                borderRadius: "4px",
                                transition: "background-color 0.2s"
                              }}
                              onMouseEnter={(e) => {
                                e.currentTarget.style.backgroundColor = "#3e3e3e";
                              }}
                              onMouseLeave={(e) => {
                                e.currentTarget.style.backgroundColor = "transparent";
                              }}
                            >
                              <img 
                                src={copyIcon} 
                                alt="Copy"
                                style={{ 
                                  width: "14px",
                                  height: "14px",
                                  filter: "brightness(0) invert(0.8)"
                                }}
                              />
                              <span>Copy</span>
                            </div>
                          </Tooltip>

                          {/* Command Content */}
                          <div style={{
                            paddingTop: "24px",
                            whiteSpace: "pre-wrap",
                            wordBreak: "break-all",
                            paddingRight: "60px",
                            paddingLeft: "4px",
                            lineHeight: "1.8"
                          }}>
                            {payload.privateSecretKey.split('\n').map((line, idx) => {
                              // Parse line for syntax highlighting
                              const renderLine = (text) => {
                                if (!text.trim()) return <span key={`empty-${idx}`}>{text}</span>;
                                
                                const elements = [];
                                let currentIndex = 0;
                                let elementCounter = 0;
                                
                                // Helper to add plain text
                                const addText = (start, end) => {
                                  if (end > start) {
                                    elements.push(
                                      <span key={`plain-${idx}-${elementCounter++}`}>
                                        {text.substring(start, end)}
                                      </span>
                                    );
                                  }
                                };
                                
                                // Match patterns in order of specificity
                                const patterns = [
                                  { 
                                    regex: /(helm install)/g, 
                                    color: '#c586c0',
                                    name: 'helm'
                                  },
                                  { 
                                    regex: /(atmosly-agent)/g, 
                                    color: '#4ec9b0',
                                    name: 'agent'
                                  },
                                  { 
                                    regex: /(\.\/charts\/agents)/g, 
                                    color: '#4ec9b0',
                                    name: 'charts'
                                  },
                                  { 
                                    regex: /(--namespace|atmosly-system|--create-namespace|-f|values\.yaml|--set clusterSecret=)/g, 
                                    color: '#4ec9b0',
                                    name: 'options'
                                  },
                                  { 
                                    regex: /("[\w]+")/g, 
                                    color: '#ce9178',
                                    name: 'secret'
                                  }
                                ];
                                
                                const allMatches = [];
                                patterns.forEach(({ regex, color, name }) => {
                                  regex.lastIndex = 0; // Reset regex
                                  let match;
                                  while ((match = regex.exec(text)) !== null) {
                                    allMatches.push({
                                      start: match.index,
                                      end: match.index + match[0].length,
                                      text: match[0],
                                      color,
                                      name
                                    });
                                  }
                                });
                                
                                // Sort and deduplicate
                                allMatches.sort((a, b) => a.start - b.start);
                                const filtered = [];
                                allMatches.forEach(match => {
                                  const overlaps = filtered.some(f => 
                                    !(match.end <= f.start || match.start >= f.end)
                                  );
                                  if (!overlaps) {
                                    filtered.push(match);
                                  }
                                });
                                
                                // Build elements
                                filtered.forEach((match, i) => {
                                  addText(currentIndex, match.start);
                                  elements.push(
                                    <span key={`${match.name}-${idx}-${i}`} style={{ color: match.color }}>
                                      {match.text}
                                    </span>
                                  );
                                  currentIndex = match.end;
                                });
                                addText(currentIndex, text.length);
                                
                                return elements.length > 0 ? elements : <span key={`fallback-${idx}`}>{text}</span>;
                              };
                              
                              return (
                                <div key={idx}>
                                  {renderLine(line)}
                                </div>
                              );
                            })}
                          </div>
                        </div>

                        {/* Warning Box */}
                        <div style={{
                          backgroundColor: "#fff7e6",
                          border: "1px solid #ffd591",
                          borderRadius: "8px",
                          padding: "12px 16px",
                          display: "flex",
                          alignItems: "flex-start",
                          gap: "12px"
                        }}>
                          <ExclamationCircleOutlined style={{
                            color: "#fa8c16",
                            fontSize: "18px",
                            marginTop: "2px",
                            flexShrink: 0
                          }} />
                          <div>
                            <div style={{
                              fontFamily: "Nunito Sans",
                              fontSize: "14px",
                              fontWeight: "600",
                              color: "#323232",
                              marginBottom: "4px"
                            }}>
                              Security Token Expiry
                            </div>
                            <div style={{
                              fontFamily: "Nunito Sans",
                              fontSize: "13px",
                              color: "#666",
                              lineHeight: "1.5"
                            }}>
                              This command includes a temporary security token that expires in <strong style={{ color: "#fa8c16" }}>24 hours</strong>. Please regenerate if installation is delayed.
                            </div>
                          </div>
                        </div>
                      </div>
                    ) : (
                      <div style={{ 
                        minHeight: "120px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        border: "1px dashed #d9d9d9",
                        borderRadius: "8px",
                        backgroundColor: "#fafafa",
                        color: "#999",
                        fontFamily: "Nunito Sans",
                        fontSize: "14px"
                      }}>
                        Click Generate Command button below to generate your Helm command.
                      </div>
                    )}
                  </Form.Item>
                </div>

                <Button
                  disabled={!!payload.privateSecretKey}
                  style={{
                    display: "inline-flex",
                    padding: "10px 57px",
                    justifyContent: "center",
                    alignItems: "center",
                    gap: "10px",
                    background: "#132f44",
                    opacity: payload.privateSecretKey ? "0.5" : "1",
                    color: "var(--color-white, #FFF)",
                    fontFamily: "Nunito Sans",
                    fontSize: "16px",
                    fontStyle: "normal",
                    fontWeight: "600",
                    lineHeight: "24px",
                    marginTop: payload.privateSecretKey ? "0" : "20px",
                    marginBottom: "20px",
                    cursor: payload.privateSecretKey ? "not-allowed" : "pointer",
                  }}
                  onClick={handleGenerateSecret}
                >
                  Generate Command
                </Button>
                
                
              </div>

              {/* <div style={{ display: "flex", cursor: "pointer", width: "fit-content", marginBottom: "20px" }} onClick={() => {
                window.open(process.env.REACT_APP_CLUSTER_TOKEN_SCRIPT_URI, "_blank");
              }}>
                <img src={learnMoreImg} style={{ marginRight: "10px" }} />
                <p style={learnMoreStyle}>Click here to download the script for private cluster create</p>
              </div> */}
            </>}
          </Box>
          {payload.selectedCloudProvider !== "Import via token" && payload.selectedClusterType !== "PRIVATE" && (
            <CreateTaskFooter buttonContent={"Bring your cluster"} givenButtonFunction1={bringYourCluster} givenButtonFunction2={handleCancel} />
          )}
        </Form>
      </div>

      <Modal
        open={!!actionRequired}
        onCancel={closeActionRequired}
        footer={null}
        centered
        width={640}
        title={isFullAccessAction ? "Enable full access for this cluster" : "Enable read access for this cluster"}
      >
        <div style={{ padding: "8px 4px" }}>
          <Alert
            type="info"
            showIcon
            style={{ marginBottom: "16px" }}
            message={actionRequired?.action_message || "Your cluster import has started. Because this AWS integration uses read-only access keys, Atmosly can't grant itself Kubernetes access on its own — enable read access using either option below so Atmosly can view nodes, pods and workloads."}
          />

          <p style={{ margin: "0 0 12px 0", fontSize: "13px", fontWeight: 600, color: "#323232" }}>
            Choose either way to enable {isFullAccessAction ? "full access" : "read access"}:
          </p>

          {/* Option 1: attach policy — show the exact name + JSON to create in AWS */}
          <div style={{ border: "1px solid #e8e8e8", borderRadius: "8px", padding: "16px", marginBottom: "12px" }}>
            <div style={{ display: "inline-block", background: "#eef2ff", color: "#3730a3", fontSize: "11px", fontWeight: 700, letterSpacing: "0.4px", borderRadius: "4px", padding: "2px 8px", marginBottom: "8px" }}>
              OPTION 1
            </div>
            <h4 style={{ margin: "0 0 6px 0", fontFamily: "Nunito Sans", fontWeight: 600, color: "#323232" }}>
              Attach the {actionPolicyName} IAM policy
            </h4>
            <p style={{ margin: "0 0 12px 0", fontSize: "13px", color: "#666" }}>
              In the AWS Console → IAM → Policies → Create policy (JSON tab), paste the document below, name it
              exactly <strong>{actionPolicyName}</strong>, then attach it
              to the IAM user backing these access keys. Re-run the import afterward.
            </p>

            {actionPolicyName && (
              <>
                <div style={{ fontSize: "12px", fontWeight: 600, color: "#323232", marginBottom: "4px" }}>Policy name</div>
                <div style={{ display: "flex", alignItems: "center", gap: "8px", marginBottom: "12px" }}>
                  <code style={{ flex: 1, background: "#f5f5f5", border: "1px solid #d9d9d9", borderRadius: "6px", padding: "8px 10px", fontSize: "12px", wordBreak: "break-all" }}>
                    {actionPolicyName}
                  </code>
                  <Button size="small" onClick={() => copyText(actionPolicyName).then(() => toggleAlert("success", "Copied", "Policy name copied"))}>
                    Copy
                  </Button>
                </div>
              </>
            )}

            {actionPolicyDocument && (
              <>
                <div style={{ fontSize: "12px", fontWeight: 600, color: "#323232", marginBottom: "4px" }}>Policy JSON</div>
                <div style={{ position: "relative", background: "#f5f5f5", border: "1px solid #d9d9d9", borderRadius: "6px", padding: "10px 12px", maxHeight: "220px", overflow: "auto" }}>
                  <Button
                    size="small"
                    style={{ position: "absolute", top: "8px", right: "8px" }}
                    onClick={() => copyText(JSON.stringify(actionPolicyDocument, null, 2)).then(() => toggleAlert("success", "Copied", "Policy JSON copied"))}
                  >
                    Copy JSON
                  </Button>
                  <pre style={{ margin: 0, paddingRight: "70px", fontSize: "12px", fontFamily: "monospace", whiteSpace: "pre", color: "#292929" }}>
                    {JSON.stringify(actionPolicyDocument, null, 2)}
                  </pre>
                </div>
              </>
            )}
          </div>

          {/* OR divider — either way is sufficient */}
          <div style={{ display: "flex", alignItems: "center", gap: "12px", margin: "12px 0" }}>
            <div style={{ flex: 1, height: "1px", background: "#e8e8e8" }} />
            <span style={{ fontSize: "12px", fontWeight: 600, color: "#999" }}>OR</span>
            <div style={{ flex: 1, height: "1px", background: "#e8e8e8" }} />
          </div>

          {/* Option 2: in-cluster agent — ops agent (full access) or debug agent (read only) */}
          <div style={{ border: "1px solid #e8e8e8", borderRadius: "8px", padding: "16px" }}>
            <div style={{ display: "inline-block", background: "#eef2ff", color: "#3730a3", fontSize: "11px", fontWeight: 700, letterSpacing: "0.4px", borderRadius: "4px", padding: "2px 8px", marginBottom: "8px" }}>
              OPTION 2
            </div>
            <h4 style={{ margin: "0 0 6px 0", fontFamily: "Nunito Sans", fontWeight: 600, color: "#323232" }}>
              Install the {actionAgentLabel}
            </h4>
            <p style={{ margin: "0 0 12px 0", fontSize: "13px", color: "#666" }}>
              Run this Helm command inside your cluster. The agent registers back to Atmosly and grants{" "}
              {isFullAccessAction ? "full access" : "read access"} from within — nothing is created in your AWS account.
            </p>
            {!helmInfo ? (
              <Button onClick={fetchAgentCommand} loading={helmFetching}>
                Generate Helm command
              </Button>
            ) : (
              <>
                {Array.isArray(helmInfo.creates) && helmInfo.creates.length > 0 && (
                  <div style={{ background: "#f6ffed", border: "1px solid #b7eb8f", borderRadius: "8px", padding: "12px 14px", marginBottom: "12px" }}>
                    <div style={{ fontWeight: 600, fontSize: "13px", marginBottom: "8px", color: "#323232" }}>
                      {helmInfo.creates_summary || "This installs the following read-only resources in your cluster:"}
                    </div>
                    <ul style={{ margin: 0, paddingLeft: "18px" }}>
                      {helmInfo.creates.map((c, i) => (
                        <li key={i} style={{ fontSize: "13px", color: "#292929", marginBottom: "4px" }}>
                          <strong>{c.kind}</strong> {c.name}{c.detail ? ` — ${c.detail}` : ""}
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
                <div style={{
                position: "relative", backgroundColor: "#1e1e1e", borderRadius: "8px",
                padding: "16px", fontFamily: "monospace", fontSize: "12px", color: "#d4d4d4",
                whiteSpace: "pre-wrap", wordBreak: "break-all"
              }}>
                <Tooltip title={tooltipTxt.helm || "Copy"} placement="topRight" open={tooltipTxt.helm && tooltipTxt.helm !== ""}>
                  <div
                    name="helm"
                    onClick={(e) => copyFunc(e, helmInfo.helm_command)}
                    style={{ cursor: "pointer", position: "absolute", top: "10px", right: "10px", display: "flex", alignItems: "center", gap: "4px", color: "#d4d4d4", fontSize: "11px" }}
                  >
                    <img src={copyIcon} alt="Copy" style={{ width: "14px", height: "14px", filter: "brightness(0) invert(0.8)" }} />
                    <span>Copy</span>
                  </div>
                </Tooltip>
                <div style={{ paddingTop: "20px", paddingRight: "60px" }}>{helmInfo.helm_command}</div>
              </div>
              </>
            )}
          </div>

          <div style={{ display: "flex", justifyContent: "flex-end", marginTop: "16px" }}>
            <Button onClick={closeActionRequired}>Done</Button>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default BringYourClusterDrawer;
